var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "forecast-invoice-wrapper" },
    [
      _vm.showingCreateInvoice
        ? _c("CreateInvoiceModal", {
            on: {
              cancel: function ($event) {
                _vm.showingCreateInvoice = false
              },
              create: _vm.createInvoice,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "forecast-invoice-wrapper-head" }, [
        _c("div", { staticClass: "forecast-invoice-wrapper-head-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("billing.myInvoices")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "forecast-invoice-wrapper-head-actions" },
          [
            _c(
              "a-select",
              {
                staticClass: "custom-select",
                attrs: { dropdownClassName: "custom-select-dropdown" },
                model: {
                  value: _vm.filters.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "type", $$v)
                  },
                  expression: "filters.type",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "all" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.allInvoices"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "manuel" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.manualInvoices"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "monthly" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.endOfPeriodInvoices"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "purchases" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.purchaseInvoices"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "wallet-deposit" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.walletDeposit"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "unpaid" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.unpaidInvoices"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "paid" } }, [
                  _vm._v(_vm._s(_vm.$t("billing.paidInvoices"))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isAdmin
              ? _c(
                  "SupsisButton",
                  {
                    on: {
                      click: function ($event) {
                        _vm.showingCreateInvoice = true
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("billing.createInvoice")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forecast-invoice-wrapper-content" },
        [
          _c("supsis-table", {
            attrs: {
              paginationCursor: _vm.paginationCursor,
              columns: _vm.getInvoiceTableColumns(),
              rows: _vm.allInvoices,
              bottomPagination: true,
              "zebra-row": false,
            },
            on: { "cursor-changed": _vm.cursorChanged },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }